import { trackAnalyticsSafely } from "./AnalyticsTracker";
import {
    RosterCollaboratorStatusFilter,
    RosterQontactPointStateFilter,
    RosterSearchPayload,
    RosterTabID,
} from "./RosterEvents";

export class RosterAnalyticsHelper {
    static trackTabShown(tabID: RosterTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.TabShown",
            payload: { tabID },
        });
    }

    static trackTabSelected(tabID: RosterTabID) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.TabSelected",
            payload: { tabID },
        });
    }

    static trackByCollaboratorShown(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByCollaborator.Shown",
            payload: { day },
        });
    }

    static trackByQontactPointShown(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.Shown",
            payload: { day },
        });
    }

    static trackByCollaboratorDateChanged(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByCollaborator.DateChanged",
            payload: { day },
        });
    }

    static trackByQontactPointDateChanged(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.DateChanged",
            payload: { day },
        });
    }

    static trackByCollaboratorRefreshed(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByCollaborator.Refreshed",
            payload: { day },
        });
    }

    static trackByQontactPointRefreshed(day: string) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.Refreshed",
            payload: { day },
        });
    }

    static trackByCollaboratorStatusFilterSelected(day: string, status: RosterCollaboratorStatusFilter) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByCollaborator.StatusFilterSelected",
            payload: { day, status },
        });
    }

    static trackByQontactPointStateFilterSelected(day: string, state: RosterQontactPointStateFilter) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.StateFilterSelected",
            payload: { day, state },
        });
    }

    static trackByQontactPointToggled(day: string, qontactPointID: string, expanded: boolean) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.QontactPointToggled",
            payload: { day, qontactPointID, expanded },
        });
    }

    static trackByQontactPointShiftToggled(day: string, qontactPointID: string, shiftInstanceID: string, expanded: boolean) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.ShiftToggled",
            payload: { day, qontactPointID, shiftInstanceID, expanded },
        });
    }

    static trackByCollaboratorSearchApplied(payload: RosterSearchPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByCollaborator.SearchApplied",
            payload,
        });
    }

    static trackByQontactPointSearchApplied(payload: RosterSearchPayload) {
        trackAnalyticsSafely({
            eventType: "WebDashboard.Roster.ByQontactPoint.SearchApplied",
            payload,
        });
    }
}
